import { HTTP } from '@/services/http'
import { Settings } from '@/settings'

export class ImageService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

	async uploadInspection(motorvehicle_id, file, catalogue=true) {
		return await super.post('/uploadinspectionimage', {
			motorvehicle_id,
			file,
			catalogue,
		}, true)
	}
}

const services = {}

export const getImageService = (inspection) => {
	if (!services[inspection]) {
		services[inspection] = new ImageService()
	}

	return services[inspection]
}

export const freeImageService = (inspection) => {
	if (services[inspection]) {
		delete services[inspection]
	}
}